import React from "react";
import { FaBook, FaLanguage, FaListUl, FaQuestionCircle } from "react-icons/fa";

function StatCard({ icon: Icon, label, value, description }) {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-indigo-700 shadow-sm dark:bg-white/10 dark:text-indigo-200">
          <Icon />
        </div>

        <div>
          <p className="text-2xl font-bold text-slate-950 dark:text-white">
            {value}
          </p>

          <p className="text-sm font-bold text-slate-700 dark:text-white/80">
            {label}
          </p>

          {description && (
            <p className="mt-1 text-xs font-medium text-slate-500 dark:text-white/45">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function LexiqueStats({ stats, discipline }) {
  return (
    <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        icon={FaBook}
        label="Termes"
        value={stats.total}
        description={`Lexique ${discipline || "Judo"}`}
      />

      <StatCard
        icon={FaListUl}
        label="Lettres"
        value={stats.letters}
        description="Entrées classées par initiale"
      />

      <StatCard
        icon={FaLanguage}
        label="Traduits"
        value={stats.withTranslation}
        description="Termes avec traduction"
      />

      <StatCard
        icon={FaQuestionCircle}
        label="À compléter"
        value={stats.withoutTranslation}
        description="Traduction absente ou vide"
      />
    </div>
  );
}

export default LexiqueStats;